module.exports = __webpack_public_path__ + "static/img/company_logo.899fee6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company_logo.png
// module id = 9DwC
// module chunks = 18